import { render, staticRenderFns } from "./MmfNoResultAlert.vue?vue&type=template&id=492bf25a&"
import script from "./MmfNoResultAlert.vue?vue&type=script&lang=js&"
export * from "./MmfNoResultAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports